var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 156,
    viewBox: "0 0 157 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.772 67.8505V67.8345L88.7127 4.20373C85.985 1.49479 82.3661 0 78.4984 0C74.6306 0 71.0117 1.49479 68.2841 4.20373L4.2577 67.8022C4.24156 67.8354 4.22427 67.8515 4.19198 67.8675C-1.41084 73.4835 -1.3949 82.5645 4.22542 88.1473C6.80324 90.7084 10.1916 92.1871 13.8114 92.3349C13.9601 92.3509 14.1088 92.3681 14.2575 92.3681H16.8192V139.185C16.818 148.463 24.4039 156 33.726 156H58.7985C61.3267 156 63.3925 153.947 63.3925 151.436V114.717C63.3925 110.481 66.8465 107.049 71.1109 107.049H85.8859C90.1503 107.049 93.6042 110.481 93.6042 114.717V151.433C93.6042 153.945 95.6702 155.997 98.1983 155.997L123.271 155.998C132.593 155.998 140.179 148.461 140.179 139.183V92.3663H142.542C146.41 92.3663 150.046 90.8715 152.773 88.1464C158.409 82.5625 158.409 73.4495 152.773 67.8494L152.772 67.8505Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.ecd1543130da8c480ec4386d82eacf04.svg";
export { ForwardRef as ReactComponent };